import * as React from 'react'
import {forwardRef, ReactNode} from 'react'
import './FormTag.scss'

type Props = {
    id: string
    children: ReactNode
}

const FormTag = forwardRef<HTMLFormElement, Props>(({id, children}, ref) => {
    return (
        <form id={id} className={'forms__tag'} ref={ref} onSubmit={(e) => e.preventDefault()}>
            {children}
        </form>
    )
})

export default FormTag
